export default "__VITE_PUBLIC_ASSET__8e4d4895__"